import {getBackendCurrencyValue, getDateFromIsoString} from '@shared/api';
import {currencyValueDivider} from '@shared/constants';
import {Stake} from '../types';
import {StakeOnBackend} from './backendTypes';

export const mapStakeFromBackend = ({
  id,
  user_id,
  group_id,
  event_id,
  event_slug,
  event_status,
  real,
  promo,
  local_amount,
  currency,
  rate,
  status,
  payout_real,
  payout_promo,
  created_at,
}: StakeOnBackend): Stake => ({
  id,
  userId: user_id,
  groupId: group_id,
  eventId: event_id,
  eventSlug: event_slug,
  eventStatus: event_status,
  real: getBackendCurrencyValue(real) as number,
  promo: getBackendCurrencyValue(promo) as number,
  localAmount: local_amount / currencyValueDivider,
  currency,
  rate,
  status,
  payoutReal: getBackendCurrencyValue(payout_real),
  payoutPromo: getBackendCurrencyValue(payout_promo),
  created: getDateFromIsoString(created_at),
});
